import { Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import { AuthTopAppBar } from '@/features/auth/components/AuthTopAppBar'
import { AuthFooter } from '@/features/auth/components/AuthFooter'
import { surfaceAuthCanvas } from '@/theme/designTokens'

/** Centered auth card shell — forgot-password, verify-otp, reset (Figma 5074-11993). */
export function AuthLayout() {
  return (
    <Box
      data-testid="auth-layout"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        maxHeight: '100dvh',
        overflow: 'hidden',
        bgcolor: surfaceAuthCanvas,
      }}
    >
      <AuthTopAppBar variant="card" />
      <Box
        component="main"
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          px: { xs: 1, sm: 2 },
          py: { xs: 1.5, sm: 4 },
          overflow: 'auto',
          bgcolor: surfaceAuthCanvas,
        }}
      >
        {/* Center short cards on desktop; on phones start at the top so tall OTP/signup cards scroll instead of overlapping the footer. */}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            my: { xs: 0, sm: 'auto' },
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <AuthFooter />
    </Box>
  )
}
